import { createClient } from "@supabase/supabase-js";
import { getLunch, getMX } from "./getLunch";
function decodeEntities(encodedString) {
    var translate_re = /&(nbsp|amp|quot|lt|gt);/g;
    var translate = {
        "nbsp":" ",
        "amp" : "&",
        "quot": "\"",
        "lt"  : "<",
        "gt"  : ">"
    };
    return encodedString.replace(translate_re, function(match, entity) {
        return translate[entity];
    }).replace(/&#(\d+);/gi, function(match, numStr) {
        var num = parseInt(numStr, 10);
        return String.fromCharCode(num);
    });
}
function fromPortal(classes) {
    return new Promise((resolve, reject) => {
        const supabase = createClient("https://hgchgftqfrtsdtadzdqw.supabase.co", process.env.REACT_APP_SUPABASE_KEY)
        //var classIds =ek Object.values(classes.classes).map((v) => classIds.id).filter((v) => )\
        supabase.functions.invoke("get-homework", {body: {url:classes.settings.homework}}).then(res => {
          var data = res.data
          console.log(data)
        var homework = {};
        var hclasses = {}
        var dates = {}
        var date = new Date();
        date.setHours(0,0,0,0);
        for (var [k, v] of Object.entries(classes.classes)) {
          if (k !== "settings" && k !== "version") {
            if (!homework.hasOwnProperty(v.id)) {
              if (k.includes("Clark")) {
                k = "Clark"
              } else if (k.includes("Webster")) {
                k = "Webster"
              }
                homework[v.id] = {"hw":{}, block:k}
                hclasses[v.id] = {"hw":[], block:k}
            }
          }
        //  console.log(homework)
        }
  
        for (let d in data) {
          if (data[d].hasOwnProperty("start")) {
            var tDate = new Date(data[d].start.replace("Z", ""));
            tDate.setHours(0,0,0,0)
          var dateString = tDate.toDateString().split(" ").slice(0, 3).join(" ")
            if (tDate >= date.getTime()) {
              var summary = decodeEntities(data[d].summary).split(": ")
              var assignment = summary.slice(1).join(": ")
         //     summary[0] = "Advanced Geometry - 1 (A)"
       
             // summary[0] = [summary[0].split("-")[0], summary[0].split("-").at(-1).split("(")[0].replace(/ /g, ""), summary[0].split("-").at(-1).split("(")[1].replace(")", "").replace(/ /g, "")].join("")
             summary[0] = summary[0].split(" - ").slice(0, -1).join(" - ")
              Object.keys(homework).forEach((c) => {
                if (c.includes(summary[0])) {
                  summary[0] = c
                }
              })
              console.log(summary[0])

           //   console.log(summary[0])
              try {
              if (homework[summary[0]]["hw"].hasOwnProperty(dateString)) {
                homework[summary[0]]["hw"][dateString].push({entry:"• "+assignment, desc:data[d].description})
              } else {
                homework[summary[0]]["hw"][dateString] = [{entry:"• "+assignment, desc:data[d].description}]
              }if (dates.hasOwnProperty(dateString)) {
                if (!classes.settings.hasOwnProperty("gcconfig") || !classes.settings.gcconfig.hasOwnProperty("courses") || classes.settings.gcconfig.courses[summary[0]] === "Portal") {
                dates[dateString][summary[0]]["hw"].push({entry:"• "+assignment, desc:data[d].description})
              }
              } else {
                if ((!classes.settings.hasOwnProperty("gcconfig") || !classes.settings.gcconfig.hasOwnProperty("courses")) || classes.settings.gcconfig.courses[summary[0]] === "Portal") {
                dates[dateString] = JSON.parse(JSON.stringify(hclasses));
                dates[dateString][summary[0]]["hw"].push({entry:"• "+assignment, desc:data[d].description})
              }
              }
            } catch (e) {
              console.log(e)
              console.log(summary[0])
              console.log(homework)
            }
            }
        }}
        // fromGC("Advanced Geometry 1A", classes.settings.gcconfig).then((data) => {
        //     console.log(data)
        // })
        var classIds = Object.values(classes.classes).map((v) => v.id)
        classIds = [...new Set(classIds)]
        var promises = []
        classIds.forEach((classId) => {
            if (classes.settings.hasOwnProperty("gcconfig") && classes.settings.gcconfig.hasOwnProperty("courses") &&classes.settings.gcconfig.courses[classId] !== "Portal") {
                promises.push(fromGC(classId, classes.settings.gcconfig))
            }
        })
        Promise.all(promises).then((data) => {
            data.forEach((d) => {
                homework[d.classId]["hw"] = d.homework
                for (var [k, v] of Object.entries(d.dates)) {
                    if (dates.hasOwnProperty(k)) {
                        dates[k][d.classId]["hw"] = v
                    } else {
                        dates[k] = JSON.parse(JSON.stringify(hclasses));
                        dates[k][d.classId]["hw"] = v
                    }
                }
            })
        getMX().then((mx) => {
        getLunch().then((lunch) => {
            homework["Lunch"] = {"hw":lunch, block:"MAIN"}
            homework["MX"] = {"hw":mx, block:"MAIN"}
        resolve([homework, dates])
        })
        })
    })
})
})
}

function fromGC(classId, gcconfig) {
    return new Promise((resolve, reject) => {
    var gcCourseId = gcconfig.courses[classId]
    return fetch("/api/gc/getCourseWork?token="+gcconfig.refresh_token+"&courseId="+gcCourseId).then((response) => response.json()).then((data) => {
        if (data.length > 0) {
            var homework = {}
            var dates = {}
            data.forEach((assignment) => {
              console.log(assignment)
                var date = new Date(assignment.dueDate.year, assignment.dueDate.month - 1, assignment.dueDate.day -1)
                var dateString = date.toDateString().split(" ").slice(0, 3).join(" ")
                if (homework.hasOwnProperty(dateString)) {
                    homework[dateString].push({entry:"• "+assignment.title, desc:assignment.description})
                } else {
                    homework[dateString] = [{entry:"• "+assignment.title, desc:assignment.description}]
                }
                if (dates.hasOwnProperty(dateString)) {
                    dates[dateString].push({entry:"• "+assignment.title, desc:assignment.description})
                } else {
                    dates[dateString] = [{entry:"• "+assignment.title, desc:assignment.description}]
                }

            })
            resolve({homework: homework, dates: dates, classId: classId})
            }
        })
    })

}

function getGCAuthURL() {
    return fetch("/api/gc/getAuthLink").then((response) => response.text())
}



export {fromPortal, getGCAuthURL};
